import React from 'react'
import { Link } from '../../../core'

/* doc
---
title: Card Header Icon
name: Card Header Icon
category: React - Bulma
parent: Card Header
---

A `CardHeaderIcon` component for adding an icon link to the `CardHeader`. This
is a wrapper for the `Link` component and should be used with a nested `Icon` component.

See [Bulma Documentation](http://bulma.io/documentation/components/card/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Card>
    <CardHeader>
      <CardHeaderIcon href="#">
        <Icon icon="chevron-right" />
      </CardHeaderIcon>
    </CardHeader>
  </Card>
```
*/
function CardHeaderIcon(props) {
  const { children, className, ...rest } = props

  const classes = [
    'card-header-icon',
    className || '',
  ]

  return (
    <Link {...rest} className={classes.join(' ')}>
      {props.children}
    </Link>
  )
}

export default CardHeaderIcon
